import React, { Component } from "react";
import {
  DKLabel,
  DKButton,
  INPUT_TYPE,
  showAlert,
  DKIcons,
  DKIcon,
  DKListPicker,
} from "deskera-ui-library";
import CustomDomainService from "../../services/customDomain";
import {
  CUSTOM_DOMAIN_WEBSITE,
  CUSTOM_DOMAIN_TIME,
} from "../../constants/Constant";
import DomainManager from "../../managers/DomainManager";

export default class CustomDomainSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newDomainName: "",
      currentDomain: DomainManager.getLatestDomain(),
      readOnly: false,
      showInput: false,
      needDomainListPicker: false,
    };
    this.defaultDomainName = "Default domain (cdn)";
  }
  componentDidMount() {
    setTimeout(() => {
      this.props.onDomainSelect(this.state.currentDomain);
    }, 100);
    this.refreshDomainList();
  }

  refreshDomainList() {
    DomainManager.getAllCustomDomainsFromAPI(() => {
      this.domainSelected(0, null);
    });
  }

  render() {
    return (
      <div
        className={
          "p-xl border-radius-s bg-gray1 column parent-width  " +
          this.props.className
        }
      >
        <DKLabel
          className="fw-b fs-m"
          text={this.state.showInput ? "Add your domain" : "Map your domain"}
        />
        <DKLabel
          className="text-gray mt-xs"
          text={
            this.state.showInput
              ? "Enter a domain to remember your page"
              : "Select a domain for your page"
          }
        />
        <div className="column mt-l parent-width">
          {this.state.showInput && this.getInputSection()}

          {!this.state.showInput && this.getDomainListSection()}

          {!this.state.showInput &&
            this.state.currentDomain &&
            this.state.currentDomain.is_verified === false && (
              <>
                <DKLabel
                  text="Your domain is in pending for approval"
                  className="mt-m"
                  style={{ color: "red" }}
                />
                <DKLabel
                  text={`Please map your domain with following CNAME: ${this.state.currentDomain.cname_value} `}
                  className="text-gray mt-s"
                />
              </>
            )}
          {!this.state.showInput &&
            this.state.currentDomain &&
            this.state.currentDomain.is_verified === true && (
              <DKLabel
                text="Your domain is live now"
                className="text-green mt-s"
              />
            )}
        </div>
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  addDomain = () => {
    if (this.state.newDomainName.trim() === "") {
      return;
    }
    const request = {
      migrate_existing_records: true,
      domain: `${this.state.newDomainName}`,
      website_type: CUSTOM_DOMAIN_WEBSITE,
    };
    CustomDomainService.save(request)
      .then((data) => {
        this.refreshDomainList();
        showAlert(
          `Please map your domain with following CNAME: ${data.cname_value}`,
          `Custom domain will take ${CUSTOM_DOMAIN_TIME} to configure after CNAME mapping is done.`
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  getInputSection() {
    return (
      <div className="column parent-width">
        <div className="row parent-width bg-white border-m border-radius-s p-s text-black  word-break-all">
          <input
            // title="Enter custom domain"
            placeHolder="www.yourdomain.com"
            type={INPUT_TYPE.TEXT}
            required={true}
            direction="vertical"
            className="bg-white text-black word-break-all parent-width border-none fs-r"
            style={{ outline: "none" }}
            value={this.state.newDomainName
              .replace("https://", "")
              .replace("http://", "")}
            onChange={(e) => {
              this.setState({ newDomainName: e.target.value });
            }}
          />
          <DKButton
            title="Add"
            className="bg-app text-white"
            onClick={() => {
              this.addDomain();
            }}
          />
          <DKButton
            icon={DKIcons.ic_close}
            className="bg-gray1 ml-s text-white"
            onClick={() => {
              this.setState({ showInput: false });
            }}
          />
        </div>

        {this.state.newDomainName.trim() === "" && (
          <DKLabel
            text="Please enter a domain name"
            className="text-red mt-s ml-s"
          />
        )}
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  getDomainListSection() {
    return (
      <div className="row justify-content-between align-items-start parent-width ">
        <div className="row justify-content-between p-h-r p-v-s border-m bg-gray1 border-radius-s position-relative cursor-hand">
          <div
            className="position-absolute parent-width parent-height "
            style={{ top: 0, left: 0 }}
            onClick={this.showDomainListPicker}
          />
          <DKLabel
            className="unselectable"
            text={
              this.state.currentDomain
                ? DomainManager.getDomainName(this.state.currentDomain)
                : this.defaultDomainName
            }
          />
          <DKIcon src={DKIcons.ic_arrow_down2} className="ic-s unselectable" />
          {this.state.needDomainListPicker && this.getDomainListPicker()}
        </div>
      </div>
    );
  }

  getDomainListPicker() {
    let arr_domainNames = DomainManager.getAllDomainNames();
    arr_domainNames.push(this.defaultDomainName);
    return (
      <DKListPicker
        data={arr_domainNames}
        className="position-absolute border-m shadow-m parent-width z-index-1"
        style={{ top: 0, left: 0 }}
        onSelect={(index, value) => {
          this.domainSelected(index, value);
          this.hideDomainListPicker();
        }}
        onClose={this.hideDomainListPicker}
        button={{
          title: "+ Add your domain",
          className: "bg-app text-white",
          onClick: () => {
            this.setState({
              showInput: true,
              newDomainName: "",
            });
            this.hideDomainListPicker();
          },
        }}
      />
    );
  }

  domainSelected = (index, value) => {
    this.setState(
      {
        showInput: false,
        currentDomain:
          value === this.defaultDomainName
            ? null
            : DomainManager.getDomainFromIndex(index),
      },
      () => {
        this.props.onDomainSelect(this.state.currentDomain);
      }
    );
  };

  showDomainListPicker = () => {
    if (!this.state.needDomainListPicker) {
      this.setState({ needDomainListPicker: true });
    }
  };
  hideDomainListPicker = () => {
    setTimeout(() => {
      this.setState({ needDomainListPicker: false });
    }, 10);
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  checkIsValidDomain(domain) {
    var re = new RegExp(
      /^(([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]|[a-zA-Z0-9])\.)*[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/
    );
    if (domain.match(re)) {
      return true;
    } else {
      return false;
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
}
